// import React from 'react';

import config from "../coreFiles/config"

function Header() {
	return (
		<>
			<div className="container-fluid bg-light position-relative shadow">
				<nav className="navbar navbar-expand-lg bg-light navbar-light py-3 py-lg-0 px-0 px-lg-5">
					<a
						href=""
						className="navbar-brand font-weight-bold text-secondary"
						style={{ fontSize: 50 }}
					>
						{/* <i className="flaticon-043-teddy-bear" /> */}
						<img
              className="img-fluid" style={{width:'75px', height:'75px'}}
              src="assets/img/logo.png"
              alt=""
            />
						<span className="text-primary schoolName">&nbsp; Swami Vivekanand 
						<small> High School</small>
						 </span>
						
					</a>
					<button
						type="button"
						className="navbar-toggler"
						data-toggle="collapse"
						data-target="#navbarCollapse"
					>
						<span className="navbar-toggler-icon" />
					</button>
					<div
						className="collapse navbar-collapse justify-content-between"
						id="navbarCollapse"
					>
						<div className="navbar-nav font-weight-bold mx-auto py-0">
							<a href={config.BASE_URL} className="nav-item nav-link active">
								Home
							</a>
							<a href="#aboutUs" className="nav-item nav-link">
								About
							</a>
							{/* <a href="team.html" className="nav-item nav-link">
								Teachers
							</a> */}
							<a href="#gallery" className="nav-item nav-link">
								Gallery
							</a>
							{/* <div className="nav-item dropdown">
								<a
									href="#"
									className="nav-link dropdown-toggle"
									data-toggle="dropdown"
								>
									Pages
								</a>
								<div className="dropdown-menu rounded-0 m-0">
									<a href="blog.html" className="dropdown-item">
										Blog Grid
									</a>
									<a href="single.html" className="dropdown-item">
										Blog Detail
									</a>
								</div>
							</div> */}
							<a href="#contactUs" className="nav-item nav-link">
								Contact
							</a>
						</div>
						<a href="tel:07422298023" className="btn btn-primary px-4">
							 <i className='fa fa-phone'></i>&nbsp; 07422–298023
						</a>
					</div>
				</nav>
			</div>

		</>
	)
}

export default Header
